import type { Feature } from './types';
import { getOrThrow } from '@tectonics/utils/getters';

type GetSupportedTraits = (feature: Feature) => ImmutableArray<string>;

export const getSupportedTraits: GetSupportedTraits = (feature) => feature.traits || [];

type GetFeatureByName = (allFeatures: ImmutableArray<Feature>, wanted: string) => Feature | undefined;

export const getFeatureByName: GetFeatureByName = (allFeatures, wanted) => allFeatures.find(feature => feature.name === wanted);

type GetSafeFeatureByName = (allFeatures: ImmutableArray<Feature>, wanted: string) => Feature;

export const getSafeFeatureByName: GetSafeFeatureByName = (allFeatures, wanted) => getOrThrow(
  getFeatureByName(allFeatures, wanted),
  `getSafeFeatureByName - there is no feature "${wanted}" in all features`
);
